export const DRAWER_WIDTH = 150;
export const LIST_WIDTH = 600;
